import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-button",
  "use": "play-button-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\" id=\"play-button\"><circle opacity=\".5\" cx=\"21\" cy=\"21\" r=\"19.385\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 38.77c9.814 0 17.77-7.956 17.77-17.77S30.813 3.23 21 3.23 3.23 11.187 3.23 21 11.187 38.77 21 38.77zM21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21z\" /><path d=\"M17.5 14.7v12.6l9.8-6.3-9.8-6.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol